export default __webpack_public_path__ + "static/media/1.4e74d8ce.png";